var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "currentColor",
    d: "M27.500,3.750 L30.000,3.750 L30.000,12.500 L27.500,12.500 L27.500,3.750 ZM22.500,-0.000 L25.000,-0.000 L25.000,12.500 L22.500,12.500 L22.500,-0.000 ZM17.500,7.500 L20.000,7.500 L20.000,12.500 L17.500,12.500 L17.500,7.500 ZM15.000,30.000 C6.716,30.000 -0.000,23.284 -0.000,15.000 C-0.000,6.716 6.716,-0.000 15.000,-0.000 L15.000,15.000 L30.000,15.000 C30.000,23.284 23.284,30.000 15.000,30.000 ZM12.500,2.751 C6.802,3.913 2.500,8.963 2.500,15.000 C2.500,17.997 3.562,20.749 5.327,22.905 L12.500,15.732 L12.500,2.751 ZM14.267,17.500 L7.095,24.673 C9.250,26.438 12.002,27.500 15.000,27.500 C21.036,27.500 26.087,23.198 27.248,17.500 L14.267,17.500 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.ef477159.svg";
export { ForwardRef as ReactComponent };